import {Component, OnDestroy, Input, OnInit} from '@angular/core';
import {FilterBase} from "../../../../../models/filter-base";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FilterbaseService} from "../../filter-base/services/filterbase.service";

@Component({
    selector: 'app-text-box',
    templateUrl: './text-box.component.html',
    styleUrls: ['./text-box.component.css'],
    standalone: false
})
export class TextBoxComponent implements OnDestroy, OnInit {
  /** Service subscriptions end with the component (they used to leak). */
  private readonly destroy$ = new Subject<void>();
  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  @Input() filterBase!: FilterBase;

  value: string = '';
  inputType: string = 'text';

  constructor(private filterBaseService: FilterbaseService) {}

  ngOnInit(): void {
    // map FilterBase type to html input type
    switch (this.filterBase.type) {
      case 'number':
        this.inputType = 'number';
        break;
      case 'search':
        this.inputType = 'text';
        break;
      default:
        this.inputType = 'text';
    }

    // preset value if exists
    if (this.filterBase.value) {
      this.value = this.filterBase.value;
      this.registerValue(this.value);
    }
    const stored = this.filterBaseService.getQuestion(this.filterBase.key);
    if (stored && !this.value) this.value = stored?.value?.value ?? stored?.label ?? String(stored);

    // listen for clear events
    this.filterBaseService.getRemoveEvent().pipe(takeUntil(this.destroy$)).subscribe(key => {
      if (key === this.filterBase.key) {
        this.clearField();
      }
    });
  }

  onValueChange(): void {
    if (this.value === '' || this.value === null || this.value === undefined) {
      this.filterBaseService.deleteQuestion(this.filterBase.key);
    } else {
      this.registerValue(this.value);
    }
  }

  registerValue(val: string): void {
    this.filterBaseService.addQuestion(this.filterBase.key, {
      id: this.filterBase.key,
      label: val,
      name: this.filterBase.key,
      value: {
        name: this.filterBase.key,
        value: val
      }
    });
  }

  clearField(): void {
    this.value = '';
    this.filterBaseService.deleteQuestion(this.filterBase.key);
  }

  get isNumber(): boolean {
    return this.filterBase.type === 'number';
  }

  get isSearch(): boolean {
    return this.filterBase.type === 'search';
  }
}
